import { Button, Col, Drawer, Row } from 'antd';
import React, { CSSProperties, useState, useEffect } from 'react';
import { UploadFileForm } from '.';
import { BolFileItem } from './BolFileItem';
import { TrackedBolFileHandler } from './UploadFileForm/TrackedBolFileHandler';
import IFilterSelectOption from '../DataGrid/FilterSelectbox/IFilterSelectOption';

export type BolFileModel = { name?: string, bolFileTypeId?: string, fileId?: string, data?: string };

interface Props {
  value?: BolFileModel[];
  onChange?: Function;
  readonly?: boolean;
  containerStyle?: CSSProperties;
  itemStyle?: CSSProperties;
  AddButtonStyle?: CSSProperties;
  fileUrl?: string;
}

export default (props: Props) => {
  const defaultFileUrl = "/api/TrackedBolFile/GetTrackedBolFileById/";

  let [addingFile, setAddingFile] = useState<boolean>(false);
  let [drawVisible, setDrawVisiable] = useState<boolean>(false);
  let [fileTypes, setFileTypes] = useState<IFilterSelectOption[]>();

  let handler = new TrackedBolFileHandler(props);

  useEffect(() => {
    getTrackedBolFileTypes();
  }, []);

  let getTrackedBolFileTypes = () => {
    handler.GetBolFileTypes().then(x => {
      const fileTypes: IFilterSelectOption[] =
        x.results?.map(y => ({
          text: y.name!,
          value: y.id!,
        })) ?? [];
      setFileTypes(fileTypes);
    })
  }

  let onItemRemoved = (item: BolFileModel) => {
    let newList = props.value?.filter(x => x != item);
    props.onChange?.call(undefined, newList);
  }

  let onFileAdded = (item: BolFileModel) => {
    setDrawVisiable(false);

    if (props.value && props.value.length) {
      props.onChange?.call(undefined, [...props.value, item]);
    } else {
      props.onChange?.call(undefined, [item]);
    }
  }

  return (<Row style={{ ...props.containerStyle }}>
    {!props.readonly &&
      <Col>
        <Button style={{ ...props.AddButtonStyle }} icon="plus" onClick={x => setDrawVisiable(true)}>Add File</Button>
      </Col>}
    <Col>
      {props.value?.map(x => (
        <BolFileItem readonly={props.readonly} style={{ ...props.itemStyle }} fileUrl={props.fileUrl ?? defaultFileUrl} item={x} key={x.name} onRemoveItem={onItemRemoved} fileTypes={fileTypes} />
      ))}
    </Col>
    <Drawer title="Upload File" visible={drawVisible} destroyOnClose={true} onClose={x => setDrawVisiable(false)} >
      <UploadFileForm onFileAdded={onFileAdded} onCancel={x => setDrawVisiable(false)} fileTypes={fileTypes} />
    </Drawer>
  </Row>);
}